import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { filter } from 'helpers/decorators'
import { Input, Select } from 'components/fields'
import { Module, Row, Col, FilterActions } from 'components/misc'
import { organizations as organizationsApi } from 'redux/modules/api'
import { apiCodeLists } from 'helpers/decorators/api'
import { FilterByCountry } from 'containers/filters/fields'

const enhance = compose(
  apiCodeLists(['organizationTypes', 'organizationStates']),
  connect(
    ({ api }) => ({
      query: api.organizations.filter,
      count: api.organizations.count
    }),
    {
      setFilter: organizationsApi.setOrganizationsFilter,
      setInitialParams: organizationsApi.setInitialParams
    }
  ),
  filter({
    form: 'award-units-filter',
    persist: true
  })
)

class FilterOrganizations extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    isDetail: PropTypes.bool
  }

  static defaultProps = {
    filterByOperatingAuthority: false,
    filterBySubOperatingAuthority: false,
    isDetail: false,
    withCountry: true
  }

  render() {
    const {
      codeLists
    } = this.props

    return (
      <Module verticallyNarrow primary>
        <Row alignItems="center" gutters inner>
          <Col flex="0 1 200px">
            <Input
              label="Search"
              intlKey="label.search"
              name="id||name@ic"
              clearable
            />
          </Col>
          <Col flex="0 1 200px">
            <Select
              label="Award Unit type"
              intlKey="label.award_unit_type"
              name="organizationType_value"
              options={codeLists.organizationTypes.list}
            />
          </Col>
            <Col flex="0 1 200px">
              <FilterByCountry name="country_id@or" multi />
            </Col>
          <Col flex="0 1 200px">
            <Select
              label="State"
              intlKey="label.state"
              name="organizationState_value"
              options={codeLists.organizationStates.list}
            />
          </Col>
          <Col flex="1 1 auto" alignSelf="flex-end" right>
            <FilterActions {...this.props} />
          </Col>
        </Row>
      </Module>
    )
  }
}

export default enhance(FilterOrganizations)
